import BaseComponent from '../base_component/base_component'

export default class ResearchDocumentSummary extends BaseComponent {

    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options)
        
        this.$component = $(this.component)
        
        $('.read-report-button').on('click', () => { this.showPopup() })
    }

    showPopup() {
        let contactEmail = $('#research-preview-contact-email').text()
        let popupHtml = `<div class="upgrade-popup">
                            <i class="upgrade-popup-quit fa fa-times-circle"></i>
                            <div class="upgrade-popup-message">
                                <h3>You'll need to upgrade your subscription plan</h3>
                                <p>Please contact: <a href="mailto:${contactEmail}">${contactEmail}</a></p>
                            </div>
                            <div class="upgrade-popup-controls">
                                <button class="upgrade-popup-cancel">Cancel</button>
                                <a href="mailto:${contactEmail}">
                                    <button class="upgrade-popup-email">Email</button>
                                </a>
                            </div>
                        </div>`
        $('body').prepend(popupHtml)
        $('.upgrade-popup-quit, .upgrade-popup-cancel').on('click', () => { this.hidePopup() })
    }

    hidePopup() {
        $('.upgrade-popup').remove()
    }
}